import React from 'react'
import { withIcon } from '../../withIcon'

function FilmIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}>
      <path fillRule="evenodd" clipRule="evenodd" d="M6 5.125C5.24061 5.125 4.625 5.74061 4.625 6.5V7.875H7.375V5.125H6ZM6 3.875C4.55025 3.875 3.375 5.05025 3.375 6.5V18.5C3.375 19.9497 4.55025 21.125 6 21.125H18C19.4497 21.125 20.625 19.9497 20.625 18.5V6.5C20.625 5.05025 19.4497 3.875 18 3.875H6ZM8.625 5.125V11.875H15.375V5.125H8.625ZM16.625 5.125V7.875H19.375V6.5C19.375 5.74061 18.7594 5.125 18 5.125H16.625ZM19.375 9.125H16.625V11.875H19.375V9.125ZM19.375 13.125H16.625V15.875H19.375V13.125ZM19.375 17.125H16.625V19.875H18C18.7594 19.875 19.375 19.2594 19.375 18.5V17.125ZM15.375 19.875V13.125H8.625V19.875H15.375ZM7.375 19.875V17.125H4.625V18.5C4.625 19.2594 5.24061 19.875 6 19.875H7.375ZM4.625 15.875H7.375V13.125H4.625V15.875ZM4.625 11.875H7.375V9.125H4.625V11.875Z" fill={color}/>
    </svg>
  )
}

export default withIcon(FilmIcon)
